import Avatar from "react-avatar";

const Avatars = ({ ...rest }) => {
  return <Avatar {...rest} />;
};

export default Avatars;
